import { Controller } from "@hotwired/stimulus"

// Horizontal-scroll shadow for shared/_scrollable_table: while the container is
// scrolled right, sticky-column cells (marked with stickyClassValue) get a
// right-edge shadow so the frozen column reads as floating above the rest.
export default class extends Controller {
  static values = { stickyClass: String }

  scroll() {
    const shadow = this.element.scrollLeft > 0 ? "4px 0 8px -4px rgba(0, 0, 0, 0.15)" : ""
    this.element.querySelectorAll(`.${this.stickyClassValue}`).forEach((el) => {
      el.style.boxShadow = shadow
    })
  }
}
